// extracted by mini-css-extract-plugin
export default {"ineligibleIngredientsGetInTouch":"G66dcb8"};